import React from "react";
import v1offImage from "../assets/v1off.jpg";
import kuantanBranchImage from "../assets/kuantan_branch.jpg";
import bgImage from "../assets/bgImage.jpg";
// import CompanyFile from '../components/CompanyFile'
import p1 from "../assets/register-logo/aelb-ori.png";
import p2 from "../assets/register-logo/cidb-ori.png";
import p3 from "../assets/register-logo/mof-ori.png";
import p4 from "../assets/register-logo/petronas-ori.png";
import col1 from "../assets/col1.png";
import col2 from "../assets/col2.png";
import col3 from "../assets/col3.jpg";
import col4 from "../assets/col4.jpg";
import location from "../assets/LocationLogo.png";
import bgImg1 from "../assets/bgImg1.jpg";
import leader from "../assets/leader.jpg";
import mof from "../assets/moflol.png";
function AboutUsTemplate() {
  const scrollToTop = () => {
    const contactSection = document.getElementById("navbar");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="bg-white border-black ">
      <div className="w-full flex justify-center items-center h-[496px] relative font-poppins border-black ">
        <div
          className="absolute inset-0 "
          style={{
            backgroundImage: `url(${leader})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>
        <div className="flex border-black z-10">
          <h1 className="font-[700] text-white text-4xl ">About Us</h1>
        </div>
      </div>

      

      <div className="flex border-black w-full p-40 font-poppins ">
        <div className="flex flex-col gap-10 border-yellow-400" data-aos="fade-up">
          <h1 className="font-[700] text-[50px]" >The Company</h1>

          <p className=" text-2xl font-[200] text-[#7A8384]">
            Vision One Sdn. Bhd. is a company that focuses on the provision of
            technical solution, inspection, nondestructive testing, maintenance
            and repair. These provisions of services adhere to the international
            standards in state-of –the-art and conventional methods with the
            goal in delivering the work with quality and utmost integrity to
            meet customer satisfaction. The company is registered and accredited
            by national and international certifying bodies. The company
            composed of congregates of highly competent, certified and qualified
            personnel in specific fields of services.
          </p>
          <p className=" text-2xl font-[200] text-[#7A8384]">
            Vision One Sdn. Bhd. together with its associate companies will form
            collaborative arrangements to achieve its business targets. The
            capacity, expertise and experiences within the group provide VOSB
            and its associate a competitive service advantage.
          </p>

          <p className=" text-2xl font-[200] text-[#7A8384]">
            Vision One Sdn. Bhd. meticulous inclination and positioning will be
            to appeal to the private and public entities the value of
            professional services from experienced personnel who are committed
            to carry out projects objectively and technically in accordance with
            the international standards and code of practice to ensure its
            viability and delivery as per requirements to meet customers’
            expectations. The utilization of state-of-the-art equipment and
            software solutions on every project will enhance customers’ ability
            to meet its operation requirements.
          </p>
        </div>
      </div>

      <div
              id="RealContentContainer"
              className="flex font-poppins border-purple-700 p-40 bg-[#f5f5f5]"
            >
            <div id="VisionContainer" className="flex flex-col gap-[60px] items-center" data-aos="fade-up">
                <div
                  id="VisionContainerTitle"
                  className="flex font-[700] text-[50px] text-[#61BBBF] text-center"
                >
                  Our Mission
                </div>

                <div
                  id="VisionContainerContent"
            className="flex flex-1 flex-col gap-[60px] border-red-500 "
            
                >
                  <div id="FirstLineContent" className="flex font-semibold text-4xl text-justify">
                  To be the leader, bridge the gap between conventional and
                    innovative solutions.
                  </div>

                  <div
                    id="SecondLineContent"
                    className="flex flex-1 font-light text-2xl text-[#7A8384] text-justify"
                  >
                    Vision One Sdn. Bhd. aspiration to be the national and
                    international leading provider of technical solution,
                    inspection, nondestructive testing, maintenance and repair
                    to the respected customers in energy, power, and
                    petrochemical industries.
                  </div>
                </div>
        </div>
        </div>

      
            <div
              id="RealContentContainer"
        className="flex font-poppins border-purple-700 p-40 bg-white"
        data-aos="zoom-in"
            >
            <div id="VisionContainer" className="flex flex-col gap-[60px] items-center">
                <div
                  id="VisionContainerTitle"
                  className="font-[700] text-[50px] text-[#61BBBF] "
                >
                  Our Vision
                </div>

                <div
                  id="VisionContainerContent"
                  className="flex flex-1 flex-col gap-[60px] border-red-500 "
                >
                  <div id="FirstLineContent" className="flex font-semibold text-4xl text-justify ">
                    Pursue, acquire, introduce and drive innovative, advanced
                    solutions into the energy, power and petrochemical
                    industries
                  </div>

                  <div
                    id="SecondLineContent"
                    className="flex flex-1 font-light text-2xl text-[#7A8384] text-justify"
                  >
                    Vision One Sdn. Bhd. committed to the mission of upholding
                    the value of customer convictions and services proficiency
                    detailed with precision. Breaking through from
                    conventional and advanced technology development in
                    equipment, facilities and personnel expertise. To implement
                    and to maintain continuous improvement of the quality system
                    to provide efficient services utilizing its resources,
                    infrastructures, and competent, qualified, and experienced
                    personnel to achieve the customer expectation and
                    satisfaction.
                  </div>
                </div>
        </div>
      </div>
      




      <div
          id="CompanyRegisteredStatusContainer"
        className=" items-center border-blue-700 flex flex-col font-poppins bg-white gap-[60px] pt-0 p-40"
        data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="1500"
        >
          <div
            id="CompanyStatusStatement"
            className="text-4xl font-[600] 2 border-red-600"
          >
            Our Collaborators
          </div>

          <div
            id="CompanyPics"
            className="flex flex-1 flex-row justify-evenly gap-[180px]  border-black"
          >
            

            <a
              href="https://www.murphyoilcorp.com"
              style={{ cursor: "pointer" }}
              target="_blank"
            >
              <img
                src={col1}
                className="w-[150px] h-[150px] object-contain"
                class="companyImg"
              ></img>
          </a>
          
          <a
              href="https://www.lottechem.co.id/main/main.asp"
              style={{ cursor: "pointer" }}
              target="_blank"
            >
              <img
                src={col2}
                className="w-[150px] h-[150px] object-contain"
                class="companyImg"
              ></img>
            </a>

            <a
              href="https://www.pvn.vn/sites/en/Pages/default.aspx"
              style={{ cursor: "pointer" }}
              target="_blank"
            >
              <img
                src={col3}
                className=" "
                class="test"
              ></img>
            </a>

            <a
              href="https://www.tnb.com.my"
              style={{ cursor: "pointer" }}
              target="_blank"
            >
              <img
                src={col4}
                className="w-[150px] h-[150px] object-contain"
                class="companyImg"
              ></img>
            </a>
          </div>
        </div>





      <div
          id="BusinessObjectivesContainer"
        className="font-poppins flex flex-col border-orange-800 gap-[60px] p-40 bg-[#f5f5f5]"
        
        >
        <div id="BusinessObjectiveTitle" className="font-[700] text-[50px]"
        data-aos="zoom-in-down">
            Our Business Objective
          </div>

          <div
            id="BusinessObjectiveElaboration"
            className="flex flex-col gap-10 font-[200] text-2xl text-[#7A8384]"
          >
            <p>
              Vision One Sdn. Bhd. is a company that focuses on the provision of
              technical solution, inspection, nondestructive testing,
              maintenance and repair. These provisions of services adhere to the
              international standards in state-of –the-art and conventional
              methods with the goal in delivering the work with quality and
              utmost integrity to meet customer satisfaction. The company is
              registered and accredited by national and international certifying
              bodies. The company composed of congregates of highly competent,
              certified and qualified personnel in specific fields of services.{" "}
            </p>

            <p>
              {" "}
              Vision One Sdn. Bhd. together with its associate companies will
              form collaborative arrangements to achieve its business targets.
              The capacity, expertise and experiences within the group provide
              VOSB and its associate a competitive service advantage.
            </p>

            <p>
              Vision One Sdn. Bhd. meticulous inclination and positioning will
              be to appeal to the private and public entities the value of
              professional services from experienced personnel who are committed
              to carry out projects objectively and technically in accordance
              with the international standards and code of practice to ensure
              its viability and delivery as per requirements to meet customers’
              expectations. The utilization of state-of-the-art equipment and
              software solutions on every project will enhance customers’
              ability to meet its operation requirements.
            </p>
          </div>
        </div>



        <div
          id="CompanyRegisteredStatusContainer"
        className=" items-center border-blue-700 flex flex-col font-poppins bg-white gap-[60px]  p-40"
        data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="1500"
        >
          <div
            id="CompanyStatusStatement"
            className="text-4xl font-[600] 2 border-red-600"
          >
            We Are Registered With 
          </div>

          <div
            id="CompanyPics"
            className="flex flex-1 flex-row justify-evenly gap-[180px]  border-black"
          >
            

            <a
              href="https://www.cidb.gov.my/eng/"
              style={{ cursor: "pointer" }}
              target="_blank"
            >
              <img
                src={p2}
                className="w-[150px] h-[150px] object-contain"
                class="companyImg"
              ></img>
          </a>
          
          <a
              href="https://www.aelb.gov.my/v2/"
              style={{ cursor: "pointer" }}
              target="_blank"
            >
              <img
                src={p1}
                className="w-[150px] h-[150px] object-contain"
                class="companyImg"
              ></img>
            </a>

            <a
              href="https://www.mof.gov.my/"
              style={{ cursor: "pointer" }}
              target="_blank"
            >
              <img
                src={mof}
                className="w-[150px] h-[150px] object-contain"
                class="companyImg"
              ></img>
            </a>

            <a
              href="https://www.petronas.com/"
              style={{ cursor: "pointer" }}
              target="_blank"
            >
              <img
                src={p4}
                className="w-[150px] h-[150px] object-contain"
                class="companyImg"
              ></img>
            </a>
          </div>
        </div>


      
        <div
          id="OfficeBranchesContainer"
          className=" border-blue-700 flex flex-col font-poppins p-40 gap-10 "
        >
          <div
            id="OfficeBranchTitle"
            className="border-pink-500 font-[700] text-[50px]"
          >
            Locate Us Here!
          </div>
          <div className="flex flex-row mt-20 gap-32 border-black ">
          <div
            className="flex flex-col w-full border-black shadow-lg"
            data-aos="fade-up"
          >
            <img
              src={require("../assets/v1off.jpg")}
              alt="Your Image"
              className="flex-shrink-0 w-full object-cover h-[400px]"
            />
            <div className="flex flex-col w-full h-full border-black justify-center py-6 px-10 rounded-bl-md rounded-br-md shadow-lg">
              <div className="flex flex-col gap-5 border-black h-full items-center mb-10">
                <h1 className="font-[600] text-lg">
                  HEAD OFFICE
                </h1>

                <p className="font-[200] text-md">Vision One Sdn. Bhd. head office is located on the first floor of a two-storey office block in a well developed commercial area in Mutiara Damansara, a well established residential commercial township</p>
              
                
              
              </div>
              <div
                  id="LeftBranchCardDescLocation"
                  className="flex flex-row gap-[23.2px] items-center text-center "
                >
                  <div id="LeftBranchCardDescLocationIcon" className="">
                    <img src={location}></img>
                  </div>
                  <div
                    id="LeftBranchCardDescLocationName"
                    className="font-[500] text[24px] text-[#000000] hover:underline hover:text-blue-500"
                  >
                    <a href="https://maps.app.goo.gl/k7TH3J3fMgJp5Y4x5" target="_blank"> <h1 className="hover: underline-offset-1">Mutiara Damansara, Petaling Jaya</h1></a>
                  </div>
                </div>

              

              {/* <div className="flex flex-col justify-center py-6 px-10 border-black border-2">
            
          </div> */}
            </div>
          </div>

          <div
            className="flex flex-col w-full border-black shadow-lg"
            data-aos="fade-up"
          >
            <img
              src={require("../assets/kuantan_branch.jpg")}
              alt="Your Image"
              className="flex-shrink-0 w-full object-cover h-[400px]"
            />
            <div className="flex flex-col w-full h-full border-black justify-center py-6 px-10 rounded-bl-md rounded-br-md shadow-lg">
            <div className="flex flex-col gap-5 border-black h-full items-center">
                <h1 className="font-[600] text-lg">
                KUANTAN BRANCH OFFICE AND YARD FACILITY
                </h1>

                <p className="font-[200] text-md">Vision One Sdn. Bhd. Kuantan branch office situated within the 2 acre yard located in the industrial area of Gebeng, Kuantan.</p>
                
              
              
              
              
              </div>

              <div
                  id="LeftBranchCardDescLocation"
                  className="flex flex-row gap-[23.2px] items-centre text-center"
                >
                  <div id="LeftBranchCardDescLocationIcon" className="">
                    <img src={location}></img>
                  </div>
                  <div
                    id="LeftBranchCardDescLocationName"
                    className="font-[500] text[24px] text-[#000000] hover:underline hover:text-blue-500"
                  >
                    <a href="https://maps.app.goo.gl/k7TH3J3fMgJp5Y4x5" target="_blank"> <h1 className="hover: underline-offset-1">Gebeng, Kuantan</h1></a>
                  </div>
                </div>

              
              {/* <div className="flex flex-col justify-center py-6 px-10 border-black border-2">
            
          </div> */}
            </div>
          </div>


        </div>

        <div className="flex flex-row  border-black justify-end">
      <button
                  onClick={scrollToTop}
                  class="text-white bg-gray-900 hover:bg-blue-500 duration-150 font-medium  text-md px-5 py-3"
                  
                >
                  <h1 className="text-5xl font">^</h1>
                </button>
      </div>
        </div>




       












      
    </div>
  );
}

export default AboutUsTemplate;
